import React, { useState } from "react";
import { DatePickerInput } from "@mantine/dates";

const DATE_OPTIONS = [
  { label: "Today", value: "today" },
  { label: "Last 7 Days", value: "last7days" },
  { label: "This Month", value: "thisMonth" },
  { label: "Last Month", value: "lastMonth" },
  { label: "Custom", value: "custom" },
];

export const getDateParams = (period, customRange = [null, null]) => {
  const now = new Date();

  if (period === "today") {
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
    return { startDate: start.toISOString() };
  }

  if (period === "last7days") {
    const start = new Date();
    start.setDate(start.getDate() - 6);
    start.setHours(0, 0, 0, 0);
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    return { startDate: start.toISOString(), endDate: end.toISOString() };
  }

  if (period === "thisMonth") {
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
    return { startDate: start.toISOString(), endDate: end.toISOString() };
  }

  if (period === "lastMonth") {
    const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const end = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999);
    return { startDate: start.toISOString(), endDate: end.toISOString() };
  }

  if (period === "custom") {
    const params = {};
    if (customRange[0]) params.startDate = customRange[0].toISOString();
    if (customRange[1]) params.endDate = customRange[1].toISOString();
    return params;
  }

  return {};
};

const DateFilter = ({ onChange }) => {
  const [period, setPeriod] = useState("today");
  const [customRange, setCustomRange] = useState([null, null]);

  const handlePeriodChange = (e) => {
    const val = e.target.value;
    setPeriod(val);
    if (val !== "custom") {
      onChange(getDateParams(val));
    }
  };

  const handleCustomRangeChange = (val) => {
    setCustomRange(val);
    if (val[0] && val[1]) {
      onChange(getDateParams("custom", val));
    }
  };

  return (
    <div className='flex items-center gap-2'>
      <div className='relative flex items-center rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-boxdark transition-colors duration-300 p-1'>
        <select
          value={period}
          onChange={handlePeriodChange}
          className='bg-white dark:bg-boxdark border-none outline-none text-gray-800 dark:text-white px-2 py-0.5 text-sm cursor-pointer'
        >
          {DATE_OPTIONS.map((opt) => (
            <option
              key={opt.value}
              value={opt.value}
              className='bg-white dark:bg-boxdark text-gray-800 dark:text-white'
            >
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      {period === "custom" && (
        <DatePickerInput
          type='range'
          placeholder='Pick date range'
          value={customRange}
          onChange={handleCustomRangeChange}
          clearable
          numberOfColumns={2}
          classNames={{
            input:
              "!bg-white dark:!bg-boxdark !text-black dark:!text-white !border-gray-300 dark:!border-gray-600 cursor-pointer",
          }}
          styles={{ input: { minWidth: 230, fontSize: 13, height: 34 } }}
        />
      )}
    </div>
  );
};

export default DateFilter;
